import { z } from "zod";

const RoleSchema = z.object({
    id: z.number(),
    name: z.string(),
    property_id: z.nullable(z.string()),
    display_name: z.string(),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
})

export const UpdateRoleResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    data: RoleSchema
});